'use strict';

angular.module('userRequestArrivalRoutes', [
        'userRequestArrivalControllers',
        'services.userAccessRequest',
        'services.lookups',
])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {

    $stateProvider

    // With event ID
    .state('userAccessRequest_withArrivalEvent', {
        url: '/UserRequest/ForArrivalEvent/{eventId:int}',
        template: '<div ui-view></div>',
        views: {
            '': {
                templateUrl: require('./RequestArrival_ErrorMessage.tpl.html'),
                controller: 'RequestArrivalWithEventIDController',
            }
        }
    })

    // With user access request ID
    .state('userAccessRequest_forArrivalEvent', {
        url: '/UserRequest/{userAccessRequestId:int}/ForArrivalEvent',
        template: '<div ui-view></div>',
        resolve: {
            authenticatedUser: ['authenticatedUserService', function (service) {
                return service.getAuthenticatedUser();
            }],
            userRequest: ['userAccessRequestService', '$stateParams', function (service, $stateParams) {
                return service.getRequest($stateParams.userAccessRequestId);
            }],
            lookups: ['loookupService', '$stateParams', function (service, $stateParams) {
                return service.getLookups();
            }],
        },
        views: {
            '': {
                templateUrl: require('./RequestArrival.tpl.html'),
                controller: 'RequestArrivalController'
            }
        }
    })
}]);